import axios from 'axios';
import { getAuthToken } from '../Utils';

export interface UserBadge {
  id: number;
  name: string;
  type: number;
}

export interface UserProfile {
  id: number;
  alias: string;
  email: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  birthday?: string;
  height?: string;
  weight?: string;
  bio?: string;
  sex?: string;
  badges: UserBadge[];
}

export const fetchCurrentUser = async (): Promise<UserProfile> => {
  const token = getAuthToken();
  const headers: Record<string, string> = {};
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const response = await axios.get('/api/users/me', {
    headers,
    withCredentials: true,
  });

  const data = response.data;
  const person = data.person || {};

  // Fetch badges
  let badges: UserBadge[] = [];
  if (data.id) {
    try {
      const badgesResponse = await axios.get(`/api/badges?userId=${data.id}&carry=true`, {
        headers,
        withCredentials: true,
      });
      badges = badgesResponse.data || [];
    } catch (error) {
      console.error('Error fetching badges:', error);
    }
  }

  return {
    id: data.id,
    alias: data.alias,
    email: data.email,
    firstName: person.FN || undefined,
    middleName: person.MN || undefined,
    lastName: person.LN || undefined,
    birthday: person.birthday || undefined,
    height: person.height ? String(person.height) : undefined,
    weight: person.weight ? String(person.weight) : undefined,
    bio: person.about || undefined,
    sex: person.sex || undefined,
    badges,
  };
};
